import { createSelector } from 'reselect';

import { getFilteredShops } from './../../shared/selectors';
import { PER_PAGE, MINIMUM_PAGE_NUMBER } from '../constants';

export default createSelector([getFilteredShops], shops =>
  shops.length ? Math.ceil(shops.length / PER_PAGE) : MINIMUM_PAGE_NUMBER
);
